import React from 'react';
import { reasons } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const WhyChooseSection = () => {
  return (
    <section id="pourquoi" className="py-24 md:py-32 bg-stone-800 text-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-stone-400 text-sm tracking-[0.25em] uppercase mb-3">
            Nos engagements
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white font-light">
            Pourquoi choisir DÉCORATION DE SOUSA FRÈRES
          </h2>
          <div className="w-16 h-px bg-stone-500 mx-auto mt-6" />
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={reason.id}
              className="relative p-8 bg-stone-700/50 rounded-lg hover:bg-stone-700 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 mt-1">
                  <CheckCircle className="w-6 h-6 text-stone-400" />
                </div>
                <div>
                  <h3 className="text-lg font-medium text-white mb-2">
                    {reason.title}
                  </h3>
                  <p className="text-stone-400 text-sm leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
              {/* Decorative number */}
              <span className="absolute top-4 right-4 font-serif text-6xl text-stone-700/30 font-light">
                {String(index + 1).padStart(2, '0')}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
